module.exports = __webpack_public_path__ + "a64a1f315ef8585c3b7d4f99711b1671.pdf";